import { App } from 'vue';

const components = import.meta.glob('../components/*.vue', {
  import: 'default',
  eager: true
});

export default function registerComponents(app: App) {
  // https://dev.to/jakedohm_34/auto-registering-all-your-components-in-vue-3-with-vite-4884
  Object.entries(components).forEach(([path, module]) => {
    const componentName = path
      .split('/')
      .pop()
      .replace(/\.\w+$/, '');

    app.component(componentName, module);
  });
}
